
const i18nextCostTypes = {
  'travel tickets': 'newExpenc.costType1',
  'taxi costs': 'newExpenc.costType2',
  'accommodation expenses': 'newExpenc.costType3',
  'parking fees': 'newExpenc.costType4',
  'other expenses': 'newExpenc.costType5',
  'other travel expenses': 'newExpenc.costType5', // KAS-774: Maksim7733
  'matkaliput': 'newExpenc.costType1',
  'taksikulut': 'newExpenc.costType2',
  'majoituskulut': 'newExpenc.costType3',
  'pysäköintimaksut': 'newExpenc.costType4',
  'muut matkakulut': 'newExpenc.costType5'
}

/**
 * Function that takes invoice items (costs) and converts the property `description`:
 * from a i18next compatible format to the desired translation:
 * (i.e. "newExpenc.costs - newExpenc.costType1" -> "Costs - travel tickets")
 *
 * @param {function} t - i18next function to translate strings.
 * @param {string|array} costRows - a cost's `description` property or array of invoice items (cost[])
 * @param {boolean|string} invoice_lang - invoice language in boolean or string format
 * @returns {string|array} modified cost-description strong or modified array of invoice items (cost[])
 */

export const extractCostTranslation = (t, costRows, invoice_lang) => {
  const translateArrItem = (item) => {
    const invoiceLangToBool = typeof invoice_lang === 'boolean'
      ? invoice_lang
      : invoice_lang === 'en'

    return typeof invoice_lang === 'undefined'
      ? t(item)
      : t(item, { lng: invoiceLangToBool ? 'en' : 'fi' })
  }

  const handleDescription = (desc) => {
    if (desc.includes('newExpenc.costs')) {
      const descriptionArr = desc.split(' - ')
      descriptionArr[0] = translateArrItem(descriptionArr[0])
      descriptionArr[1] = translateArrItem(descriptionArr[1])
      return descriptionArr.join(' - ')
    }
    return desc
  }

  if (Array.isArray(costRows)) {
    return costRows.map((cost) => {
      const translatedCost = handleDescription(cost['description'])
      return { ...cost, description: translatedCost }
    })
  }

  return handleDescription(costRows)
}


/**
 * Function that takes invoice items, and converts the property `description` exclusively for
 * costs/expenses items: from a human-readable format to the equivalent i18next format:
 * (i.e. "Costs - travel tickets" -> "newExpenc.costs - newExpenc.costType1")
 *
 * @param {string|array} invoiceRows - a cost's `description` property or array of invoice items (cost[])
 * @returns {string|array} modified cost-description strong or modified array of invoice items (cost[])
 */

export const convertCostsToi18next = (invoiceRows) => {
  const handleConversion = (cost) => {
    if (String(cost['invoice_expense_id']) !== '-1') {
      const descriptionArray = cost['description'].split('-').map(item => item.trim())
      descriptionArray[0] = 'newExpenc.costs'
      descriptionArray[1] = i18nextCostTypes[descriptionArray[1].toLowerCase()]

      return descriptionArray.join(' - ')
    }
    return cost['description']
  }

  if (Array.isArray(invoiceRows)) {
    return invoiceRows.map(cost => {
      const convertedCost = handleConversion(cost)
      return { ...cost, description: convertedCost }
    })
  }

  return handleConversion(invoiceRows)
}